class SlideAnime {
  constructor(){
    this.event();
  }
  event(){
    const btn = document.getElementById('btnText');

    $('.sp-menu').click(function() {
        $(this).toggleClass('active');
        if ($(this).hasClass('active')) {
            btn.textContent = 'CLOSE';
            $('.globalMenuSp').addClass('active');
        } else {
            btn.textContent = 'MENU';
            $('.globalMenuSp').removeClass('active');
        } 
    });
    $('.globalMenuSp a[href]').click(function() {
        $('.globalMenuSp').removeClass('active');
        $('.sp-menu').removeClass('active');
    });
  }
}
